export default __webpack_public_path__ + "locales/lo-LA/PeopleTranslations.json?hash=f85b8a63ce871773d784d7131cebe242";